import { Link } from "@mui/material";
import { Link as domLink } from "react-router-dom";
import Constants from "./Constants";

const getConfirmationLetterListHead = () => {
  return [
    {
      id: "id",
      numeric: false,
      disablePadding: true,
      label: "ID",
      visible: false,
    },
    {
      id: "referNoLink",
      numeric: false,
      disablePadding: true,
      label: "リファー番号",
      visible: true,
    },
    {
      id: "confirmationDestination",
      numeric: false,
      disablePadding: true,
      label: "相手先名",
      visible: true,
    },
    {
      id: "confirmationLetterStatusLabel",
      numeric: false,
      disablePadding: true,
      label: "確認状態",
      visible: true,
    },
    {
      id: "confirmationResultLabel",
      numeric: false,
      disablePadding: true,
      label: "確認結果",
      visible: true,
    },
  ];
};

export const getConfirmationLetterListHeadForConfirmer = () => {
  return [
    {
      id: "id",
      numeric: false,
      disablePadding: true,
      label: "ID",
      visible: false,
    },
    {
      id: "referNoLink",
      numeric: false,
      disablePadding: true,
      label: "リファー番号",
      visible: true,
    },
    {
      id: "companyName",
      numeric: false,
      disablePadding: true,
      label: "被監査企業",
      visible: true,
    },
    {
      id: "desiredCollectionDateFormatted",
      numeric: false,
      disablePadding: true,
      label: "回収希望日",
      visible: true,
    },
    {
      id: "confirmationTypeLabel",
      numeric: false,
      disablePadding: true,
      label: "確認状種別",
      visible: true,
    },
    {
      id: "confirmationLetterStatusLabelForConfirmer",
      numeric: false,
      disablePadding: true,
      label: "状態",
      visible: true,
    },
  ];
};
export const confirmationLetterDataMapper = (data, role) => {
  return data?.data?.map((row) => ({
    ...row,
    referNoLink: (
      <Link to={`/${role}/confirmationLetter/${row.id}`} component={domLink}>
        {row.referNo}
      </Link>
    ),
    confirmationLetterStatusLabelForConfirmer:
      row.confirmationLetterStatus ===
      Constants.CONFIRMATION_LETTER_STATUS.SHIPPED
        ? "回答待ち"
        : row.confirmationLetterStatus ===
          Constants.CONFIRMATION_LETTER_STATUS.WAITING_FOR_APPROVAL_OF_CONFIRMER
        ? "承認待ち "
        : "",
    // クライアントの場合、発送済み以降は削除不可
    disableDelete:
      role === Constants.ROLE.CLIENT &&
      !(
        row.confirmationLetterStatus ===
          Constants.CONFIRMATION_LETTER_STATUS.REGISTERED ||
        row.confirmationLetterStatus ===
          Constants.CONFIRMATION_LETTER_STATUS.WAITING_FOR_SHIPMENT
      ),
  }));
};
export default getConfirmationLetterListHead;
